import { setAuthData, setIsLoggedIn } from 'redux/store/slices/authSlice'
import TokenService from 'services/token.service'
import type {
  GetDecryptedUserInfoPayload,
  GetDecryptedUserInfoResponse,
  SendOtpPayload,
  SendOtpResponse,
  VerifyOtpPayload,
  VerifyOtpResponse
} from 'share/types/api/auth'

import { api } from '.'

const authApi = api.injectEndpoints({
  endpoints: build => ({
    sendOTP: build.mutation<SendOtpResponse, SendOtpPayload>({
      query: phone => ({
        url: '/users/auth/send/',
        method: 'post',
        body: {
          phone
        }
      })
    }),
    getTokenOTP: build.mutation<VerifyOtpResponse, string>({
      query: userId => ({
        url: `/users/auth/${userId}/info/`,
        method: 'get'
      }),
      async onQueryStarted(_, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled
          dispatch(setIsLoggedIn(true))
          dispatch(
            setAuthData({
              access: data.access,
              refresh: data.refresh
            })
          )
          TokenService.setJWTTokens({
            access: data.access,
            refresh: data.refresh
          })
        } catch (error) {
          dispatch(setIsLoggedIn(false))
        }
      }
    }),
    verifyOTP: build.mutation<VerifyOtpResponse, VerifyOtpPayload>({
      query: body => ({
        url: '/users/auth/verify/',
        method: 'post',
        body
      }),
      async onQueryStarted(_, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled
          dispatch(setIsLoggedIn(true))
          dispatch(
            setAuthData({
              access: data.access,
              refresh: data.refresh
            })
          )
          TokenService.setJWTTokens({
            access: data.access,
            refresh: data.refresh
          })
        } catch (error) {
          dispatch(setIsLoggedIn(false))
        }
      }
    }),
    getDecryptedUserInfo: build.mutation<GetDecryptedUserInfoResponse, GetDecryptedUserInfoPayload>({
      query: body => ({
        url: '/users/data-encrypted/',
        method: 'post',
        body
      })
    })
  })
})

export const { useSendOTPMutation, useGetTokenOTPMutation, useVerifyOTPMutation, useGetDecryptedUserInfoMutation } =
  authApi
